module.exports = __webpack_public_path__ + "static/media/person3.efe960e4.jpg";